import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
  import { VueDaumPostcode } from 'vue-daum-postcode';
  import { IAddressAutocompleteData } from './type';

  export interface IEmits {
    (event: 'complete', data: IAddressAutocompleteData): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["complete"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'complete', data: IAddressAutocompleteData): void;
  }), expose: any, slots: any, attrs: any }) {

  const offcanvasVisible = ref(false);
  const q = ref('');
  
  // https://postcode.map.daum.net/guide
  const onComplete = (data: any) => {
    emits('complete', {
      street_address: data.address,
      locality: data.sido,
      region: data.sigungu,
      postal_code: data.zonecode
    });
    offcanvasVisible.value = false;
  };

return (_ctx: any,_cache: any) => {
  const _component_AppOffcanvas = _resolveComponent("AppOffcanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppOffcanvas, {
      modelValue: offcanvasVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((offcanvasVisible).value = $event)),
      class: "offcanvcas-address-autocomplete"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(VueDaumPostcode), {
          q: q.value,
          "no-submit-mode": "",
          "always-show-eng-addr": "",
          onComplete: onComplete
        }, null, 8, ["q"]), [
          [_vShow, offcanvasVisible.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (offcanvasVisible.value = true))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})